
export function Enumerable(target: unknown, propertyKey: string, descriptor: PropertyDescriptor) {
    
    descriptor.enumerable = true;
}
